import router from '@/router'
import get  from 'lodash/get'
import mapValues from 'lodash/mapValues'

export const definitions = {
    'text.message' : {
        message: (vue, notification) => {
            return `${notification.comment.message}`
        },
        dropdownTitle: 'Nova mensagem!',
        dropdownIcon: 'icon-message-circle'
    },

    'unknown' : {
        message: (vue, notification) => {
            return `TIPO DE NOTIFICAÇÃO DESCONHECIDO: ${notification.type || 'broadcastType undefined'}`
        },
        onClick: (service, notification) => service.markAsRead(notification),
    }
    ,
    'schedule_suggestion.confirmed' : {
        message: (vue, notification) => {
            return notification.comment.message
        },
        dropdownTitle: 'Confirmação de Agenda',
        dropdownIcon: 'icon-calendar',
        onClick: (service, notification) => {
            service.markAsRead(notification)
            const eventId = get(notification, 'extraData.event_id', null)
            if (eventId !== null) {
                router.push(`/schedules?e_id=${eventId}`)
            } else {
                console.info("Not possible to open even schedule for the clicked notification")
            }
        }
    },
    'open.form.message' : {
      message: (vue, notification) => {
          return notification.comment.message
      },
      dropdownTitle: 'Novo formulário',
      dropdownIcon: (notification) => {
        return get(notification, 'extraData.icon', 'icon-message-circle')
      },
      onClick: (service, notification) => {
          service.markAsRead(notification)
          //const formId = get(notification, 'extraData.form_id', null)
          const formPath = get(notification, 'extraData.form_path', null)
          if (formPath !== null) {
              router.push(`/${formPath}`)
          } else {
              console.info("Not possible to open form handling for the clicked notification")
          }
      }
  }
}

export const withMissingDefaults = (definitions) => {
    return mapValues(definitions, (definition) => {
        return {
            ...definition,
            dropdownDuration: ('dropdownDuration' in definition) ? definition.dropdownDuration : defaults.duration,
            dropdownPosition: ('dropdownPosition' in definition) ? definition.dropdownPosition : defaults.position,
            dropdownTitle: ('dropdownTitle' in definition) ? definition.dropdownTitle : defaults.title,
            dropdownIcon: ('dropdownIcon' in definition) ? definition.dropdownIcon : defaults.icon,
            dropdownCategory: ('dropdownCategory' in definition) ? definition.dropdownCategory : defaults.category,
            onClick: ('onClick' in definition)? definition.onClick : defaults.onClick
        }
    })
}

const defaults = {
    duration: 5000,
    position: 'top-center',
    title: 'Notificação',
    icon: 'icon-bell',
    category: 'primary',
    onClick: (service, notification) => service.openNewTab(notification)
}

// onClick(service)(vue, notification)
